module.exports = __webpack_public_path__ + "e3115f6e5b7f7d99fd4fffe18c5a56fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Blue1.jpg
// module id = 15
// module chunks = 0